import "./index.scss";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setOpenedModal } from "../../../redux/actions";
import gsap from "gsap";
import Humburger from "../../common/humburger";

const Menu = ({ setOpenedModal }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const tl = gsap;
    if (isOpen) {
      tl.to("html", 0, {
        overflowY: "hidden",
      });

      tl.to(".menu__link", 0.3, {
        opacity: 1,
        transform: "translateX(0vw)",
        stagger: 0.05,
      });
    } else {
      tl.to("html", 0, {
        overflowY: "scroll",
      });
      tl.to(".menu__link", 0.1, {
        opacity: 0,
        transform: "translateX(-30vw)",
        stagger: 0.03,
      });
    }
  }, [isOpen]);

  const openModal = (e, type) => {
    if (type) {
      setOpenedModal(type);
    }

    setIsOpen(false);
  };

  return (
    <>
      <Humburger isOpen={isOpen} handleClick={() => setIsOpen(!isOpen)} />
      <div
        className={`menu ${isOpen && "menu--active"} ${
          isOpen && "menu--hidden"
        } `}
      >
        <div className={`menu__item`}>
          <a
            onClick={(e) => openModal(e, "gallery")}
            href="#"
            className={`menu__link`}
          >
            notify me
          </a>
        </div>
        <div className={`menu__item menu__item--mt`}>
          <a
            href="#mission"
            onClick={openModal}
            className={`menu__link menu__link--sections`}
          >
            mission
          </a>
          <a
            onClick={openModal}
            href="#gallery"
            className={`menu__link menu__link--sections`}
          >
            gallery
          </a>
          <a
            href="#match"
            onClick={openModal}
            className={`menu__link menu__link--sections`}
          >
            match
          </a>
          <a
            onClick={openModal}
            href="#proof"
            className={`menu__link menu__link--sections`}
          >
            proof
          </a>
        </div>
        <div className={`menu__item menu__item--mt`}>
          <a
            onClick={(e) => openModal(e, "contactus")}
            href="#"
            className={`menu__link`}
          >
            Contact Us
          </a>
          <span
            onClick={(e) => openModal(e, "appSupport")}
            href="#"
            className={`menu__link`}
          >
            App Support
          </span>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setOpenedModal: (value) => dispatch(setOpenedModal(value)),
});

export default connect(null, mapDispatchToProps)(Menu);
